<template>
  <div class="container-fluid">
    <div>
      <div
        class="col-12 row justify-content-between container-partners__search pr-0 pl-0 ml-0 mb-3"
      >
        <div
          class="col-xs-mobile col-6 col-sm-6 col-md-7 col-lg-7 col-xl-7 pl-0"
        >
          <form class="d-flex form-partner">
            <i
              class="fas fa-search inputFilter md-filter-input fa-flip-horizontal"
            ></i>
            <input
              v-model="searchValue"
              class="form-control inputFilter md-filter-input me-2"
              type="text"
              placeholder="Buscar por nombre o correo electrónico"
              aria-label="Search"
              @keyup="searchPartnerUsers"
            />


            <div class="md-layout md-gutter">
              <div class="md-layout-item" style="padding: 0px !important">
                <md-field class="sort-box select-partners">
                  <md-select
                    v-model="sortType"
                    class="custom-select filter inputFilter sort-select sort-portrait md-filter-input md-sort-select"
                  >
                    <md-option value="" selected hidden>Filtrar por</md-option>
                    <md-option value="newest">Nuevo</md-option>
                    <md-option value="oldest">Antiguo</md-option>
                    <md-option value="asc">A-Z</md-option>
                    <md-option value="desc">Z-A</md-option>
                  </md-select>
                </md-field>
              </div>
            </div>
          </form>
        </div>


      </div>
      <div class="partner">
        <div class="container-partners">
          <el-table
            v-if="isLoading"
            class="table-responsive table-flush"
            header-row-class-name="thead-light"
            :data="[1, 2, 3, 4, 5, 6]"
          >
            <el-table-column
              label="Nombre"
              min-width="150px"
              prop="title"
              sortable
            >
              <template #default>
                <skeleton-square
                  :box-properties="{
                              height: '16px',
                              top: '10px',
                            }"
                />
              </template>
            </el-table-column>
            <el-table-column
              label="Estado"
              min-width="150px"
              prop="title"
              sortable
            >
              <template #default>
                <skeleton-square
                  :box-properties="{
                              height: '16px',
                              top: '10px',
                            }"
                />
              </template>
            </el-table-column>
            <el-table-column
              label="País"
              min-width="150px"
              prop="title"
            >
              <template #default>
                <skeleton-square
                  :box-properties="{
                              height: '16px',
                              top: '10px',
                            }"
                />
              </template>
            </el-table-column>
            <el-table-column
              label="Cursos"
              min-width="60px"
              prop="title"
              sortable
            >
              <template #default>
                <skeleton-square
                  :box-properties="{
                              height: '16px',
                              top: '10px',
                            }"
                />
              </template>
            </el-table-column>
            <el-table-column
              label="Correo electrónico"
              min-width="200px"
              prop="title"
              sortable
            >
              <template #default>
                <skeleton-square
                  :box-properties="{
                              height: '16px',
                              top: '10px',
                            }"
                />
              </template>
            </el-table-column>
            <el-table-column
              label="Acciones"
              min-width="70px"
              prop="title"
              sortable
            >
              <template #default>
                <skeleton-square
                  :box-properties="{
                              height: '16px',
                              top: '10px',
                            }"
                />
              </template>
            </el-table-column>
          </el-table>
          <el-table
            v-else
            :data="getPartnerUsers"
            class="table-responsive table-flush coupon-single"
            header-row-class-name="thead-light"
          >
            <el-table-column
              label="Nombre"
              min-width="150px"
              prop="code"
              sortable
            >
              <template #default="{ row }">
                <div class="media align-items-center">
                  <div class="media-body">
                    <div class="font-weight-500 name mb-0 text-sm">
                      <div class="coupon-code">
                        <h3 class="mb-0 ml-2">{{ row.name }}</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Estado"
              min-width="150px"
              prop="expiration"
              sortable
            >
              <template #default="{ row }">
                <div class="media align-items-center">
                  <div class="media-body">
                    <!-- registrado = activo -->
                    <badge
                      v-if="row.status === userStatusOptions.USER_STATUS_ACTIVE"
                      class="status-active"
                      type="success"
                    >ACTIVO
                    </badge>
                    <badge
                      v-if="row.status === userStatusOptions.USER_STATUS_INACTIVE"
                      class="status-inactive"
                      type="secondary"
                    >INACTIVO
                    </badge>
                    <badge
                      v-if="
                    row.status === userStatusOptions.USER_STATUS_UNVERIFIED
                  "
                      class="status-pending"
                      type="secondary"
                    >NO VERIFICADO
                    </badge>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="País"
              min-width="150px"
              prop="expiration"
              sortable
            >
              <template #default="{ row }">
                <div class="media align-items-center">
                  <div class="media-body">
                    {{ row?.country?.name || 'SIN ASIGNAR' }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Cursos"
              min-width="60px"
              prop="expiration"
              sortable
            >
              <template #default="{ row }">
                <div class="d-flex flex-row bd-highlight">
                  <md-avatar
                    :class="[
                        (row.partner_courses || []).length
                          ? 'coursesActives'
                          : 'bg-light',
                      ]"
                    class="md-avatar-icon ml-0 mr-2"
                  >
                    {{ (row.partner_courses || []).length }}
                  </md-avatar>
                  <div v-if="(row.partner_courses || []).length" class="py-1">
                    <i
                      class="fas fa-bars"
                      role="button"
                      @click="handlePartnerCourses(row)">
                    </i>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Correo electrónico"
              min-width="200px"
              prop="code"
              sortable
            >
              <template #default="{ row }">
                <div class="media align-items-center">
                  <div class="media-body">
                    <div class="font-weight-500 name mb-0 text-sm">
                      <div class="coupon-code">
                        <h3 class="mb-0 ml-2">{{ row.email }}</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Acciones" min-width="70px" prop="edit">
              <template #default="{ row }">
              <span class="mt-1">
                <md-menu :md-offset-x="-127" :md-offset-y="-20" md-size="auto">
                  <md-button md-menu-trigger>•••</md-button>
                  <md-menu-content>
                       <md-menu-item
                         type="primary"
                         @click="openUserDialog(row)"
                       >

                        Editar
                    </md-menu-item>
                    <md-menu-item
                      type="primary"
                      @click="openDeleteUserDialog(row)"
                    >

                        Eliminar
                    </md-menu-item>
                  </md-menu-content>
                </md-menu>
              </span>
              </template>
            </el-table-column>
          </el-table>
          <div
            v-if="totalPages > 1"
            class="card-footer pt-4 pb-2 d-flex justify-content-end border-top-0"
          >
            <base-pagination
              :value="page"
              class="pagination-style"
              :page-count="totalPages"
              @input="paginationChange"
            ></base-pagination>
          </div>
        </div>
      </div>
    </div>
    <delete-dialog
      :is-open="isOpenDeleteUser"
      :is-loading="deleteUserLoading"
      @deleted="deleteUser"
      @close-modal="closeDeleteUserDialog"
      @success="fetchPartnerUsers"
    />
    <user-dialog
      :is-open="isOpenUpdateUser"
      :selected-user="selectedUser"
      @close-modal="closeUserDialog"
      @success="fetchPartnerUsers"
    />
  </div>
</template>

<script>

import {
  Table,
  TableColumn,
} from 'element-ui';
import { FETCH_PARTNER_USERS, PARTNER_INVITATION_LIST } from '@/store/actions/partner';
import { mapGetters } from 'vuex';
import SkeletonSquare from '@/components/Skeleton/components/SkeletonSquare.vue';
import moment from 'moment-timezone';
import { USER_STATUS_ACTIVE, USER_STATUS_INACTIVE, USER_STATUS_UNVERIFIED } from '@/util/constants';
import UserDialog from '@/views/Pages/Admin/Users/components/UserDialog.vue';
import DeleteDialog from '@/views/Pages/Admin/components/DeleteDialog.vue';
import { DELETE_USER } from '@/store/actions/user';

export default {
  name: 'ListPartner',
  components: {
    DeleteDialog, UserDialog,
    SkeletonSquare,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data: () => ({
    isLoading: true,
    searchValue: null,
    sortType: '',
    isFilter: false,
    active: false,
    value: null,
    page: 1,
    deleteUserLoading: false,
    isOpenDeleteUser: false,
    isOpenUpdateUser: false,
    selectedUser: undefined,
    userStatusOptions: {
      USER_STATUS_ACTIVE,
      USER_STATUS_INACTIVE,
      USER_STATUS_UNVERIFIED,
    },
  }),
  computed: {
    ...mapGetters(['getPartnerUsers', 'getAllCountries']),
    totalPages () {
      return Math.ceil(this.getPartnerUsers.total / this.perPage);
    },
  },
  watch: {
    sortType: function(newValue) {
      this.isLoading = true;
      this.fetchPartnerUsers({
        search: this.searchValue,
        per_page: 20,
        order_by: newValue,
      });
    },
  },
  mounted () {
    this.fetchPartnerUsers();
  },
  methods: {
    openDeleteUserDialog (user) {
      this.selectedUser = user;
      this.isOpenDeleteUser = true;
    },
    openUserDialog (user) {
      this.selectedUser = user;
      this.isOpenUpdateUser = true;
    },
    closeDeleteUserDialog () {
      this.selectedUser = undefined;
      this.isOpenDeleteUser = false;
    },
    deleteUser () {
      this.deleteUserLoading = true;
      this.$store
        .dispatch(DELETE_USER, this.selectedUser)
        .then(() => {
          this.notify('success', 'Se ha eliminado el usuario con éxito');
          this.fetchPartnerUsers();
          this.closeDeleteUserDialog();
          this.deleteUserLoading = false;
        })
        .catch((error) => {
          this.notify('danger', error.response.data.message);
          this.deleteUserLoading = false;
        });
    },
    closeUserDialog () {
      this.selectedUser = undefined;
      this.isOpenUpdateUser = false;
    },
    notify (type, message) {
      this.$notify({
        type: type,
        verticalAlign: 'top',
        horizontalAlign: 'right',
        message: message,
      });
    },
    searchPartnerUsers (event) {
      if (event.key === 'Enter') {
        this.fetchPartnerUsers();
      }
    },
    handlePartnerCourses (partner) {
      this.$router.push(`partners/courses/${partner.id}`);
    },
    fetchPartnerUsers (
      filter = {
        per_page: 20,
        order_by: this.descOrder ?? this.sortType,
        search: this.searchValue,
      },
    ) {
      this.$store
        .dispatch(FETCH_PARTNER_USERS, filter)
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.notify('danger', 'Tenemos problemas para cargar los usuarios');
        });
    },
    async paginationChange (page) {
      this.isLoading = true;
      this.page = page;
      await this.$store.dispatch(PARTNER_INVITATION_LIST, {
        page: this.page,
        per_page: this.perPage,
      });
      this.isLoading = false;
    },
  },
};
</script>
